module.exports = __webpack_public_path__ + "static/media/simple.a1ca9240.frag";